import { useCatalog } from '@/hooks/CatalogContext';
import type { SortKey } from '@/types/data';

export function SortableMetricHeader({
  sortKey,
  label,
  title,
}: {
  sortKey: SortKey;
  label: string;
  title: string;
}) {
  const { prefs, setSort } = useCatalog();
  const active = prefs.sortKey === sortKey;
  const ariaSort = active
    ? prefs.sortDirection === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none';

  return (
    <th aria-sort={ariaSort}>
      <button
        type="button"
        onClick={() => setSort(sortKey)}
        title={title}
        className="tooltip"
      >
        {label}
        {active ? (prefs.sortDirection === 'desc' ? ' ↓' : ' ↑') : ''}
      </button>
    </th>
  );
}
